var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"btnAsideHide"}},[_c('img',{attrs:{"src":_vm.$ebConfig.imgPath+'img/aside-btn.jpg'},on:{"click":_vm.hide}})])}
var staticRenderFns = []

export { render, staticRenderFns }